import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useDeviceStore } from "../../../stores/Assets/device";
import { t } from "i18next";

const AddDevice = ({ toggleAddDeviceModal, showAddDeviceModal, spaceList }) => {
  const { createDevice } = useDeviceStore((state) => state);
  const [formData, setFormData] = useState({
    device_id: "",
    space_id: "",
    is_active: true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const success = await createDevice(formData);
      if (success) {
        toggleAddDeviceModal();
        setFormData({
          device_id: "",
          space_id: "",
          is_active: true,
        });
      }
    } catch (error) {
      console.error("Error creating device:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={showAddDeviceModal}
      toggle={toggleAddDeviceModal}
      size="lg"
      centered
    >
      <ModalHeader toggle={toggleAddDeviceModal}>
        {t("Add New Device")}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="device_id">{t("Device ID")} *</Label>
                <Input
                  id="device_id"
                  name="device_id"
                  type="text"
                  value={formData.device_id}
                  onChange={handleInputChange}
                  placeholder="Enter 6-digit device ID"
                  maxLength={6}
                  pattern="[0-9]{6}"
                  required
                />
                <small className="text-muted">
                  Must be exactly 6 digits (e.g., 123456)
                </small>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="space_id">{t("Space")} *</Label>
                <Input
                  id="space_id"
                  name="space_id"
                  type="select"
                  value={formData.space_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">{t("Select a space")}</option>
                  {spaceList.map((space) => (
                    <option key={space.space_id} value={space.space_id}>
                      {space.space_id} - {space.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleInputChange}
                  />
                  {t("Active")}
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleAddDeviceModal}
            disabled={isSubmitting}
          >
            {t("Cancel")}
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={isSubmitting || !formData.device_id || !formData.space_id}
          >
            {isSubmitting ? t("Creating...") : t("Create Device")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddDevice;
